module.exports = __webpack_public_path__ + "static/media/Whatsapp.54b8fe27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Whatsapp.svg
// module id = 300
// module chunks = 25